<template>
  <modal-pop
    :opened.sync="popupShow"
    :no-negative-button="true"
    confirm="MCOM-0000054"
    cancel="MCOM-0000055"
    @confirm="extendLogin"
    @cancel="logout"
  >
    <template #content>
      <div>
        <strong class="text-info">{{ /*자동 로그아웃 남은시간*/ $t("MCOM-0000007") }}</strong>
        <p class="log-timer">00:{{ _.padStart(limit, 2, '0') }}</p>
        <p>- {{/*고객님의 안전한 금융거래 보호를 위해 로그인 후 약 10분 동안 이용이 없어 자동로그아웃됩니다.*/ $t("MCOM-0000008") }}</p>
        <p>- {{/*로그인 시간을 연장하시려면 로그인 연장하기 버튼을 클릭하여 주십시오. */ $t("MCOM-0000009")}}</p>
      </div>
    </template>
  </modal-pop>
</template>

<script>
// import { mapFields } from "vuex-map-fields";
import { mapGetters, mapActions } from "vuex";
import Common from "@/components/basic/Common";
export default {
  extends: Common,
  data() {
    return {
      popup: false,
      timer: null,
      limit: this.$config.AUTO_LOGOUT_TIMER,
    };
  },
  mounted() {
    this.$store.watch(
      state => state.idleVue.isIdle,
      isIdle => {
        if (this.isLogin && !this.popup && isIdle) {
          this.popupShow = true;
        }
      },
    );
  },
  computed: {
    ...mapGetters(["isLogin"]),
    popupShow: {
      get() {
        return this.popup;
      },
      set(value) {
        this.popup = this.getIsPopup() == 0 ? value : false;
        if (this.timer == null && this.popup) {
          this.timer = setInterval(() => {
            this.limit--;
            if (this.limit === 0) {
              this.logout();
            }
          }, 1000);
        }
      },
    },
  },
  methods: {
    ...mapActions(["actAllStateReset", "ACT_SET_SESSIONINFO_ALL", "ACT_EXEC_LOGOUT"]),
    close() {
      this.popup = false;
      this.limit = this.$config.AUTO_LOGOUT_TIMER;
      clearInterval(this.timer);
      this.timer = null;
    },
    /**
     * 로그아웃
     */
    logout() {
      this.limit = this.$config.AUTO_LOGOUT_TIMER;
      this.close();
      this.ACT_EXEC_LOGOUT();
      this.$emit("logout");
      this.goMain();
    },
    /**
     * 로그인 연장
     */
    extendLogin() {
      const _this = this;

      this.$post(
        "/commonbiz/auth/sessionExtend",
        {},
        function () {
          _this.limit = _this.$config.AUTO_LOGOUT_TIMER;
          _this.close();
        },
        function () {
          _this.close();
        },
      );
    },
    getIsPopup() {
      return document.querySelectorAll(".modal").length;
    },
  },
};
</script>